/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import './MerchantV1.scss';
import { Plus, ChevronDown, ChevronRight, ChevronUp } from 'sushiweb/Icons';
import { green } from 'sushiweb/tokens/color';
import { Modal, CopyText } from '../../../UiKit';
import { ToolTip } from '../../ComponentsV1/ToolTip/Tooltip';
import { merchantModel, userModel } from '../../../api';
import { AlternativeNumbers, MerchentTagDescription } from '../../popups';
import {
  MERCHANT_EVENTS,
  sendMerchantApiEvents,
  sendMerchantModalEvents,
} from '../../../helpers/analytics/merchant.analytics';
import { OrderIssuesImagesV1 } from '../Order/OrderIssuesImages/OrderIssuesImagesV1';
import { WFHCall } from '../../../components/commons';
import { InstallationDetails } from '../InstallationDetails/InstallationDetails';
import { RiderComplaintImages } from '../Valet/RiderComplaintImages/RiderComplaintImages';
import { Headset, ShoppingCart, TriangleAlert } from 'lucide-react';
import { OrderTag } from '../Order/OrderBasicInfo/OrderTags';
import { MerchantNumberV1 } from './MerchantNumberV1';
import { MerchantCallClickEvent } from '../../../analytics/call-logging/events';
import { FindServiceableMerchantsModalClickEvent } from '../../../analytics/store-serviceability/events';
import { MetricsForJumboEvent } from '../../../analytics/constants';
import toast from 'react-hot-toast';
import ServiceableStoresComp from '../Order/ServiceableStores';

export default class MerchantV1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchant: null,
      selectedMerchantTag: {},
    };
  }

  componentDidMount() {
    this.getMerchantInfo();
  }

  getMerchantInfo = () => {
    const { orderId, userId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    merchantModel
      .getMerchantData(queryStrings)
      .then((response) => {
        if (!response || response?.isError === true) return null;
        sendMerchantApiEvents(
          MERCHANT_EVENTS.GET_MERCHANT_DETAILS_SUCCESS,
          orderId,
          userId,
        );
        this.setState({
          merchant: { ...response },
        });
      })
      .catch(() => {
        sendMerchantApiEvents(
          MERCHANT_EVENTS.GET_MERCHANT_DETAILS_FAILURE,
          orderId,
          userId,
        );
      });
  };

  render() {
    const { merchant } = this.state;
    if (!merchant) {
      return <Shimmer height='100%' width='100%' />;
    }
    return <MerchantComp {...this.props} merchant={merchant} />;
  }
}
class MerchantComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlternativeNumbersPopup: false,
      showTagDescription: false,
      showAllMerchantinfo: false,
      showServiceableMerchantsPopUp: false,
      checkServiceableMerchants: false,
      showFindServiceableMerchantsPopup: false,
    };
  }

  closeAlternativeNumbersPopup = () => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_ALTERNATE_NUMBER_MODAL_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showAlternativeNumbersPopup: false,
    });
  };

  showAlternativeNumbersPopup = (alternateNumbers) => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_ALTERNATE_NUMBER_MODAL_OPEN,
      orderId,
      userId,
    );
    this.setState({
      showAlternativeNumbersPopup: true,
      alternativeNumbers: alternateNumbers,
    });
  };

  getPhoneNumbers = (details, showOtherDetails = false) => {
    const { orderId, userId, isWFH, cartId } = this.props;
    let calledTo = 'Merchant';

    if (!details?.phone) return null;
    return (
      <div className='tw-flex tw-flex-col tw-gap-4'>
        {showOtherDetails ? (
          <div className='tw-w-full tw-flex tw-items-center tw-gap-3 tw-h-7'>
            <ToolTip
              className='tw-flex-1'
              placement='bottom'
              content={
                <div className='tw-flex tw-flex-col tw-gap-1'>
                  <span data-dd-privacy='mask'>
                    <strong>Name: </strong>
                    {details.name}
                  </span>
                  {details.email && details.email !== 'None' ? (
                    <span data-dd-privacy='mask'>
                      <strong>Email: </strong>
                      {details.email}
                    </span>
                  ) : null}
                </div>
              }
            >
              <div
                className='tw-flex-1 tw-block tw-text-zinc-600 tw-font-medium tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-leading-none tw-pb-2'
                style={{
                  textDecoration: 'underline dotted',
                  textUnderlineOffset: '4px',
                }}
                data-dd-privacy='mask'
              >
                {details.name}
              </div>
            </ToolTip>
            <div className='tw-text-[1.3rem] tw-border-solid tw-text-zinc-600 tw-font-medium tw-border-teal-200 tw-border-[1px] tw-rounded-md tw-bg-teal-100/50 tw-px-2 tw-py-[0.4rem] tw-whitespace-nowrap tw-leading-none tw-w-fit tw-ml-2'>
              {details.role}
            </div>
          </div>
        ) : null}

        {/* Merchant's phone number and Calling */}
        <div className='tw-w-full tw-flex tw-items-center tw-gap-2'>
          <Headset size={16} className='tw-text-grey-600' strokeWidth={2} />

          <MerchantNumberV1
            phone={details?.phone}
            designation={details?.role}
            calledTo={calledTo}
            orderId={orderId}
            userId={userId}
          />

          {isWFH ? (
            <WFHCall
              orderId={orderId}
              userId={userId}
              title={details.phone}
              calledTo={calledTo}
              calledToType={details.role}
              sendJumboEvent={true}
              jumboEventFunc={MerchantCallClickEvent}
              JumboEventProperties={{
                merchant_name: details?.name,
                is_new_ui: true,
                called_to: calledTo,
                role: details?.role,
                phone: details?.phone,
              }}
              cartId={cartId}
            />
          ) : null}
        </div>
      </div>
    );
  };

  handleMerchantDetails = () => {
    const showDetails = this.state.showAllMerchantinfo;
    this.setState({
      showAllMerchantinfo: !showDetails,
    });
  };

  getAllPhoneNumbers = (smDetails, tlDetails, asmDetails, alternateNumbers) => {
    const { showAllMerchantinfo } = this.state;
    const allDetails = [];
    if (smDetails?.phone) allDetails.push(smDetails);
    if (tlDetails?.phone) allDetails.push(tlDetails);
    if (asmDetails?.phone) allDetails.push(asmDetails);
    return (
      <div className='wrap tw-w-full'>
        {allDetails?.length > 1 ? (
          showAllMerchantinfo ? (
            <div className='tw-flex-col'>
              {allDetails.map((details, index) => {
                return <div key={index}>{this.getPhoneNumbers(details)}</div>;
              })}
              <div
                className='colorGreen tw-text-300 tw-font-regular'
                onClick={this.handleMerchantDetails}
              >
                View Less <ChevronUp color={'#50b547'} />
              </div>
            </div>
          ) : (
            <div className='tw-flex-col'>
              {this.getPhoneNumbers(allDetails[0])}
              <button
                type='button'
                className='colorGreen tw-text-300 tw-font-regular'
                onClick={this.handleMerchantDetails}
              >
                View More <ChevronDown color={'#50b547'} />
              </button>
            </div>
          )
        ) : allDetails?.length === 0 ? null : (
          allDetails.map((details) => {
            return <>{this.getPhoneNumbers(details)}</>;
          })
        )}

        <div>
          {alternateNumbers?.length ? (
            <ToolTip content='Other Contact Numbers'>
              <button
                type='button'
                className='pointer'
                onClick={this.showAlternativeNumbersPopup.bind(
                  this,
                  alternateNumbers,
                )}
              >
                <Plus size={20} color={green.z500} />
              </button>
            </ToolTip>
          ) : null}
        </div>
      </div>
    );
  };

  openTagDescriptionPop = (item) => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_TAG_DESCRIPTION_MODAL_OPEN,
      orderId,
      userId,
    );
    this.setState({
      showTagDescription: item?.texts?.length ? true : false,
      selectedMerchantTag: item,
    });
  };

  closeTagDescriptionPop = () => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_TAG_DESCRIPTION_MODAL_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showTagDescription: false,
    });
  };

  componentDidMount() {
    this.getUserData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.orderId !== this.props.orderId ||
      prevProps.userId !== this.props.userId
    ) {
      this.getUserData();
    }
  }

  getUserData = () => {
    let queryStrings = {};
    queryStrings['order_id'] = this.props.orderId;
    userModel.getUserData(queryStrings).then((response) => {
      if (!response || response?.isError) return null;
      this.setState({
        checkServiceableMerchants: response?.show_check_serviceable_store,
        showFindServiceableMerchantsPopup:
          response?.show_find_serviceable_merchants_popup,
      });
    });
  };

  viewMerchantsHandler = () => {
    FindServiceableMerchantsModalClickEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId,
      [MetricsForJumboEvent.cart_id]: this.props.cartId,
      [MetricsForJumboEvent.customer_id]: this.props.userId,
    });
    if (!this.state.checkServiceableMerchants)
      return toast.error(
        'You dont have access to find serviceable merchants. please reach out to your POC',
      );
    this.setState({
      showServiceableMerchantsPopUp: !this.state.showServiceableMerchantsPopUp,
    });
  };

  render() {
    const { merchant, orderId, userId, isWFH, orderBasicInfo } = this.props;

    if (!merchant) return null;

    const {
      showAlternativeNumbersPopup,
      alternativeNumbers,
      showTagDescription,
      selectedMerchantTag,
      showAllMerchantinfo,
    } = this.state;

    const smDetails = merchant?.sm_details || {};
    const asmDetails = merchant?.asm_details || {};
    const tlDetails = merchant?.tl_details || {};

    const detailsOnFront = smDetails?.name
      ? smDetails
      : asmDetails?.name
      ? asmDetails
      : tlDetails;

    // check if the merchant details includes more than one entity details (SMs, ASMs and TLs)
    const entitiesCount = [smDetails, asmDetails, tlDetails].filter(
      (detail) => detail?.name,
    ).length;
    const areMultipleEntities = entitiesCount > 1;

    const display_text = merchant?.disruption;

    const have_tl_or_asm_details =
      merchant?.tl_details?.name || merchant?.asm_details?.name;

    return (
      <div className='tw-flex-col tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-border-grey-200 tw-h-full tw-w-full'>
        {/* upper section */}
        <div className='tw-border-solid tw-h-[65px] tw-border-[1px] tw-border-grey-200 tw-border-x-0 tw-border-t-0 tw-p-2 tw-flex tw-items-center tw-gap-2'>
          {/* Merchant icon */}
          <div className='tw-h-full tw-aspect-square tw-bg-teal-100 tw-rounded-[6px] tw-justify-center tw-items-center tw-border-solid tw-border-teal-200/50 tw-border-[1px]'>
            <ShoppingCart size={22} />
          </div>

          <div className='tw-flex-col tw-h-full tw-w-full tw-justify-between tw-overflow-hidden'>
            <div className='tw-flex tw-justify-between tw-w-full tw-items-center tw-gap-1'>
              <div
                className={`tw-text-zinc-500 tw-font-medium  tw-flex tw-gap-1 ${
                  merchant.tags?.length ? '' : 'tw-mt-1'
                }`}
              >
                <span className='tw-whitespace-nowrap'>Merchant #</span>
                <CopyText title={merchant.id} />
              </div>
              <MerchantTags tags={merchant.tags} />
            </div>

            <ToolTip content={merchant.name || ''}>
              <span
                className={
                  'tw-text-[16px] tw-mb-[1px] tw-text-zinc-600 tw-font-medium tw-whitespace-nowrap tw-overflow-hidden tw-text-left tw-text-ellipsis'
                }
                data-dd-privacy='mask'
              >
                {merchant.name}
              </span>
            </ToolTip>
          </div>
        </div>

        {/* Middle section */}
        <div className='tw-border-solid tw-h-[95px] tw-border-[1px] tw-border-grey-200 tw-border-x-0 tw-border-t-0 tw-p-4 tw-flex-col tw-gap-3 tw-bg-grey-100/40 tw-overflow-hidden'>
          {detailsOnFront?.phone ? (
            this.getPhoneNumbers(detailsOnFront, true)
          ) : (
            <div className='tw-text-grey-600 tw-text-[1.4rem] tw-font-medium tw-items-start tw-gap-1 tw-leading-none'>
              No contacts available.
            </div>
          )}

          {display_text?.title ? (
            <div className='tw-w-full tw-flex tw-items-center tw-gap-2 tw-overflow-hidden'>
              <div>
                <TriangleAlert
                  size={16}
                  color={display_text.color || '#bf2938'}
                  strokeWidth={2}
                />
              </div>
              <ToolTip
                className='tw-flex-1'
                placement='bottom'
                content={
                  <div className='tw-flex tw-flex-col tw-gap-3'>
                    <span className='tw-leading-none tw-font-medium tw-text-[1.4rem]'>
                      {display_text.title}
                    </span>
                    {display_text.subtitle && (
                      <span className='tw-leading-none tw-font-medium tw-text-grey-100 tw-text-[1.4rem]'>
                        Status: {display_text.subtitle}
                      </span>
                    )}
                  </div>
                }
                disabled={!display_text.subtitle}
              >
                <div
                  className='tw-flex-1 tw-block tw-text-[1.4rem] tw-mb-[1px] tw-font-medium tw-text-left tw-text-zinc-600 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis'
                  style={{
                    color: display_text.color || '#bf2938',
                    textDecoration: 'underline dotted',
                    textUnderlineOffset: '2px',
                  }}
                >
                  {display_text.title}
                </div>
              </ToolTip>
            </div>
          ) : null}
        </div>

        {/* Lower section */}
        <div className='tw-flex tw-w-full tw-flex-1'>
          <div className='tw-px-3 tw-py-4 tw-pr-5 tw-flex-col tw-gap-4 tw-flex tw-w-full tw-h-full tw-justify-end'>
            {orderBasicInfo?.order?.is_installation_opted ? (
              <div className='tw-flex tw-items-center tw-justify-between'>
                <InstallationDetails orderId={orderId} />
              </div>
            ) : null}
            <div className='tw-flex tw-items-center tw-justify-between tw-gap-2'>
              {have_tl_or_asm_details && areMultipleEntities ? (
                <p
                  className='tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer tw-leading-none'
                  onClick={this.handleMerchantDetails}
                >
                  View Merchant Details
                </p>
              ) : null}
              {/* Rider Uploaded Images */}
              {orderBasicInfo?.order?.should_show_rider_image ? (
                <RiderComplaintImages orderId={orderId} userId={userId} />
              ) : null}
            </div>
            <div className='tw-flex tw-items-center tw-justify-between'>
              {/* Find serviceable merchants */}
              {this.state.showFindServiceableMerchantsPopup && (
                <div
                  className={`tw-text-300 tw-font-medium tw-cursor-pointer tw-leading-none ${
                    this.state.checkServiceableMerchants
                      ? 'tw-text-green-700'
                      : 'tw-text-grey-600 '
                  }`}
                  onClick={this.viewMerchantsHandler}
                >
                  Find Serviceable Merchants
                </div>
              )}
              {/* Complaint Images */}
              <OrderIssuesImagesV1 orderId={orderId} userId={userId} />
            </div>
          </div>

          {showAllMerchantinfo && (
            <MerchantDetails
              handleMerchantInfoModal={this.handleMerchantDetails}
              detailsToShow={{
                smDetails: { ...smDetails },
                tlDetails: { ...tlDetails },
                asmDetails: { ...asmDetails },
              }}
              getPhoneNumbers={this.getPhoneNumbers}
            />
          )}

          <Modal
            isVisible={showAlternativeNumbersPopup}
            title='Other Merchant Contact Numbers'
            type='medium'
            handleClose={this.closeAlternativeNumbersPopup.bind(this)}
            component={
              <AlternativeNumbers
                alternativeNumbers={alternativeNumbers}
                orderId={orderId}
                userId={userId}
                isWFH={isWFH}
                calledTo='Merchant'
              />
            }
          />
          {showTagDescription && (
            <Modal
              isVisible={showTagDescription}
              title={`${selectedMerchantTag?.tag_text} tag description`}
              type='medium'
              handleClose={this.closeTagDescriptionPop.bind(this)}
              component={
                <MerchentTagDescription texts={selectedMerchantTag.texts} />
              }
            />
          )}

          {this.state.showServiceableMerchantsPopUp && (
            <Modal
              isVisible
              type='medium'
              title={
                <div className='tw-font-medium tw-text-[2rem] tw-text-[#1C1C1C]'>
                  Check Store Serviceability
                </div>
              }
              maxHeight='72vh'
              paddingTop='0'
              handleClose={this.viewMerchantsHandler}
              padding={0}
              containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
              component={
                <ServiceableStoresComp
                  orderId={this.props.orderId}
                  cartId={this.props.orderBasicInfo?.order?.cart_id}
                  userId={this.props.userId}
                />
              }
            />
          )}
        </div>
      </div>
    );
  }
}

const DetailTableComp = ({ details, title, getPhoneNumbers }) => {
  const detailKeys = Object.keys(details);
  if (!title) return null;
  return (
    <div className='tw-flex tw-flex-col tw-border-solid tw-border-grey-200 tw-rounded-xl'>
      <div className='tw-text-300 tw-font-semibold tw-justify-start tw-items-center tw-px-2 tw-py-3 tw-border-solid tw-border-grey-200 tw-border-x-0 tw-border-t-0'>
        {title}
      </div>
      <div className='tw-flex'>
        {detailKeys.map((key, index) => (
          <div
            className={`tw-py-4 tw-px-4  tw-flex-1 tw-flex tw-flex-col tw-items-start tw-justify-center ${
              index < detailKeys?.length - 1
                ? 'tw-border-solid tw-border-grey-200 tw-border-y-0 tw-border-l-0'
                : ''
            }`}
            key={`detail-${title || 'row'}-${key}`}
          >
            <p className='tw-text-100 tw-font-medium tw-text-grey-600 tw-w-full'>
              {key}
            </p>
            <p
              className='tw-text-400 tw-font-medium tw-w-full'
              data-dd-privacy='mask'
            >
              {key === 'phone' ? getPhoneNumbers(details) : details[key] || '-'}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const MerchantDetails = (props) => {
  const { handleMerchantInfoModal, detailsToShow, getPhoneNumbers } = props;
  const merchantDetailsTypes = Object.keys(detailsToShow);

  const detailsTableComp = (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-6'>
      {merchantDetailsTypes.map((merchantDetail) => {
        return (
          <DetailTableComp
            key={`merchant-detail-${merchantDetail}`}
            title={detailsToShow[merchantDetail]?.role}
            details={detailsToShow[merchantDetail]}
            getPhoneNumbers={getPhoneNumbers}
          />
        );
      })}
    </div>
  );

  return (
    <Modal
      isVisible={true}
      title={'Merchant Details'}
      type='large'
      handleClose={handleMerchantInfoModal}
      component={detailsTableComp}
      paddingTop={10}
    />
  );
};

const MerchantTags = ({ tags }) => {
  const [showAllTags, setShowAllTags] = useState(false);

  if (!tags || tags.length === 0) return null;

  const validTags = tags.filter(Boolean);

  const visibleTags = validTags.slice(0, 1);
  const hiddenTags = validTags.slice(1);
  const shouldShowChevron = validTags.length > 1;

  const renderTag = (item, key) => (
    <ToolTip
      content={item.tool_tip || ''}
      placement={window.dashboard.mode == 'smartplug' ? 'left' : 'bottom'}
      key={key}
    >
      <div>
        <OrderTag bgColor={item.bg_color} textColor={item.color}>
          {item.text}
        </OrderTag>
      </div>
    </ToolTip>
  );

  const handleMouseEnter = () => {
    clearTimeout(window.hideMerchantTagsTimeout);
    setShowAllTags(true);
  };

  const handleMouseLeave = () => {
    window.hideMerchantTagsTimeout = setTimeout(() => {
      setShowAllTags(false);
    }, 300);
  };

  return (
    <div className='tw-flex tw-gap-2 tw-h-full'>
      {visibleTags.map((item, index) => renderTag(item, `visible-${index}`))}

      {shouldShowChevron && (
        <div className='tw-relative tw-inline-block'>
          <div
            className='tw-cursor-pointer tw-w-6 tw-rounded-md tw-flex tw-items-center tw-justify-center hover:tw-bg-grey-200/50 tw-transition-all tw-duration-200 tw-ease-in-out tw-p-[2px]'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <ChevronRight
              size={22}
              aria-hidden
              focusable='false'
              color='#318616'
            />
          </div>

          {/* Popover with remaining tags */}
          <div
            className={`tw-absolute tw-left-full tw-top-0 tw-ml-2 tw-z-20 tw-rounded-lg tw-bg-grey-200 tw-shadow-md tw-flex tw-items-start tw-justify-center tw-p-2 tw-flex-col tw-gap-2 tw-transition-all tw-duration-200 tw-ease-out ${
              showAllTags
                ? 'tw-opacity-100 tw-translate-x-0 tw-scale-100'
                : 'tw-opacity-0 tw-translate-x-[-8px] tw-scale-95 tw-pointer-events-none'
            }`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <span className='tw-font-medium tw-text-[1.2rem] tw-leading-tight tw-whitespace-nowrap'>
              Other Merchant Tags:
            </span>
            <div className='tw-flex tw-flex-wrap tw-justify-center tw-gap-2 tw-max-w-xs'>
              {hiddenTags.map((item, index) =>
                renderTag(item, `hidden-${index}`),
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
